import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Page from '../../components/Page';
import Utils from '../../utils';
import RoutesUtils from '../../utils/routes';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';
import DriveItemUtils from '../../utils/driveItem';

const mapStateToProps = (state: StoreState) => {
	const {
		search,
		routerParamsHistory,
		driveList: { driveItems },
		galleryInfos: {
			config: { applicationGallery },
		},
	} = state;

	let prevOriginParam = '';
	const prevRoute = routerParamsHistory[routerParamsHistory.length - 2];

	if (prevRoute && prevRoute.params.origin !== DriveItemListOrigin.Search) {
		prevOriginParam = prevRoute.params.originParam;
	}

	const prevDriveItemId = prevOriginParam ? +prevOriginParam : applicationGallery;
	const isPrevDriveItemFetched = Utils.isDriveItemFetched(prevDriveItemId);

	let backgroundColor = isPrevDriveItemFetched
		? driveItems[prevDriveItemId].bgColor
		: '';
	let backgroundUrl = isPrevDriveItemFetched
		? driveItems[prevDriveItemId].bgMedia
		: '';

	if (backgroundUrl) {
		backgroundUrl = DriveItemUtils.getFolderBgMediaPath(prevDriveItemId, backgroundUrl);
	}

	const origin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const originParam = RoutesUtils.getCurrentOriginParam(routerParamsHistory);

	if (origin) {
		const isFolder = origin === DriveItemListOrigin.Folder;
		const driveItemId = isFolder
			? +originParam || applicationGallery
			: applicationGallery;
		const isDriveItemFetched = Utils.isDriveItemFetched(driveItemId);

		if (isDriveItemFetched) {
			backgroundColor = driveItems[driveItemId].bgColor;
			backgroundUrl = driveItems[driveItemId].bgMedia;

			if (backgroundUrl) {
				backgroundUrl = DriveItemUtils.getFolderBgMediaPath(driveItemId, backgroundUrl);
			}
		}
	}

	const isDefaultBackground = !backgroundColor && !backgroundUrl;

	if (isDefaultBackground) {
		backgroundUrl = driveItems[applicationGallery] ? driveItems[applicationGallery].bgMedia : '';

		if (backgroundUrl) {
			backgroundUrl = DriveItemUtils.getFolderBgMediaPath(applicationGallery, backgroundUrl);
		}
	}

	return {
		showSearchField: search.isShown,
		origin,
		originParam,
		backgroundUrl,
		backgroundColor,
		isVideoBackground: backgroundUrl &&
			DriveItemUtils.videoExtensions.includes(`.${Utils.getFileExtension(backgroundUrl)}`),
	};
};

export default connect(mapStateToProps)(Page);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Page/index.tsx